import service from '../axios'

/**
 * 认证相关API接口
 */
const authAPI = {
  /**
   * 用户登录
   * @param {Object} loginData - 登录信息
   * @param {string} loginData.username - 用户名
   * @param {string} loginData.password - 密码
   * @returns {Promise} - 返回登录结果
   */
  login(loginData) {
    return service.post('/login', loginData)
  },

  /**
   * 用户登出
   * 注意：这个接口主要是前端处理，清除localStorage中的token
   * 实际项目中可能需要调用后端登出接口
   * @returns {Promise} - 返回登出结果
   */
  logout() {
    // 清除localStorage中的token
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    return Promise.resolve({ success: true })
  }
}

export default authAPI